module.exports = "/assets/data/9afeb58d7a6521ffa915e1479ee50934-DG11.data.json";